import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DashboardHeader from '../../dashboardNavigation/DashboardHeader';
import Loader from '../../Loader';
import './ProductList.css';
import ProductRow from './ProductRow';
import Pagination from './Pagination';
import ProductEditPopup from './ProductEditPopup';
import { fetchProducts } from '../../../Action/productAction';

const ITEMS_PER_PAGE = 10;

function ProductList() {
  const dispatch = useDispatch();
  const { products, meta, loading, error } = useSelector((state) => state.products);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isPopupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchProducts(filters, currentPage, ITEMS_PER_PAGE));
  }, [dispatch, currentPage, filters]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
    setSelectedProduct(null);
  };

  const handleSave = () => {
    handleClosePopup();
    dispatch(fetchProducts(filters, currentPage, ITEMS_PER_PAGE)); // Refresh product list after saving
  };

  return (
    <div className="product-list">
      <DashboardHeader onSearch={handleSearch} />
      <h1>Product List</h1>

      {loading ? (
        <Loader />
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>SR No.</th>
                <th>Name</th>
                <th>Status</th>
                <th>Select Variation</th>
              </tr>
            </thead>
            <tbody>
            {Array.isArray(products) && products.length > 0 ? (
    products.map((product, index) => (
      <ProductRow
        key={product.id}
        product={product}
        index={index}
        currentPage={currentPage}
        onEditClick={handleEditClick}
      />
    ))
  ) : (
    <tr>
      <td colSpan="4">No products found</td>
    </tr>
  )}
            </tbody>
          </table>
        </div>
      )}

      {!error && (
        <>
          <Pagination
            currentPage={currentPage}
            totalPages={meta.totalPages}
            onPageChange={handlePageChange}
          />
          <div className="pagination-info">
            <p>Total Records: {meta.totalRecords}</p>
            <p>Total Pages: {meta.totalPages}</p>
          </div>
        </>
      )}

      {isPopupVisible && selectedProduct && (
        <ProductEditPopup
          product={selectedProduct}
          onClose={handleClosePopup}
          onSave={handleSave}
        />
      )}
    </div>
  );
}

export default ProductList;
